module.exports = __webpack_public_path__ + "static/01-e1f95ff98d61c19a7738ce79a88129f0.jpg";